
<!-- <dashboardnav> -->

    <cradua-incident-about
    [incidentAbouts]="incidentAbouts$ | async"
    (incidentAbout)="onSubmitIncidentAbout($event)"
    (deleteIncidentAboutEvent)="onDeleteIncidentAbout($event)"
    *ngIf="(isLoadingIncidentAbout$ | async ) === false"
    >
  </cradua-incident-about>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingIncidentAbout$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  <!-- </dashboardnav> -->

